import React from 'react';
import PropTypes from 'prop-types';

import { Icon, Label } from '@atlas/ui';

import { getParsedFormErrorParameters } from 'common/utils';

const GlobalErrors = ({ globalErrors }) => {
  if (!globalErrors.length) {
    return null;
  }

  const renderErrors = globalErrors?.map(error => {
    const { message, type, violationInfo } = error;

    const isValidType = typeof type === 'string';

    const errorContent = isValidType ? (
      <Label message={type} params={getParsedFormErrorParameters(violationInfo)} />
    ) : (
      message
    );

    return (
      <div className="notification-card" key={type}>
        <Icon name="error" />

        <div className="notification-card__text">{errorContent}</div>
      </div>
    );
  });

  return renderErrors;
};

GlobalErrors.propTypes = {
  globalErrors: PropTypes.arrayOf(PropTypes.object),
};

export default GlobalErrors;
